<template>
	<div>
		<el-dialog class="close-private cps-dialog-icon-line-height"
			width="40%"
			:visible.sync="visible"
			:title="$t('listPage.text.delete')"
			:close-on-click-modal="false"
			:before-close="handleClose">
			<div class="reinstall-tip">
				{{$t('mirror.tips.deleteMirror')}}
			</div>
			<!--镜像列表-->
			<el-table 
				:data="[rowInfo]" style="width:100%"
				:empty-text="$t('speechCraft.listEmptyText')">
				<!--ID-->
				<el-table-column :label="$t('mirror.text.mirrorId')" 
					min-width="200" 
					key="imageId">
					<template slot-scope="scope">
						<span>{{scope.row.imageId |
							maybeEmpty}}</span>
					</template>
				</el-table-column>
				<!--镜像名称-->
				<el-table-column prop="imageName" key="imageName"
					:label="$t('mirror.text.mirrorName')">
					<template slot-scope="scope">
						<span>{{scope.row.imageName |
							maybeEmpty}}</span>
					</template>
				</el-table-column>
				<!--镜像类型-->
				<el-table-column prop="imageKind" key="imageKind"
					:label="$t('mirror.text.mirrorType')">
					<template slot-scope="scope">
						<span>{{scope.row.imageKindName |
							maybeEmpty}}</span>
					</template>
				</el-table-column>
				<!--操作系统版本-->
				<el-table-column prop="systemVersion" 
					:label="$t('mirror.text.systemVersion')">
					<template slot-scope="scope">
						<span>{{scope.row.systemVersion | maybeEmpty}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDel">{{ $t('privateNetInstance.cancel') }}</el-button>
				<el-button @click="sureDel" type="primary">
					{{ $t('privateNetInstance.sure') }}
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {deleteImageApi} from '@/api/mirror/list/actions'

export default {
	name: 'DeleteMirror',

	props: {
		visible: {
			type: Boolean,
			default: false
		},
		region: {
			type: String,
			default: ''
		},
		rowInfo: {
			type: Object,
			default: () => {}
		},
		pageSource: {
			type: String,
			default: ''
		}
	},
	data() {
		return {


		};
	},
	computed: {
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
		},
		/**
		 * 取消删除操作
		 */
		cancelDel() {
			this.handleClose();
		},
		/**
		 * 确定删除打开操作保护
		 */
		sureDel() {
			this.deleteMirror();
		},
		/**
		 * 删除镜像
		 * @param headers
		 */
		deleteMirror() {
			const params = {
				imageId: this.rowInfo.imageId,
				region: this.region,
			};
			deleteImageApi(params).then(() => {
				this.$emit('refresh');
			}).finally(() => {
				this.handleClose();
			});
		},
	},

};
</script>

<style lang="scss">
	.close-private{
		.reinstall-confirm-checkbox{
			margin-top: 30px;
			margin-bottom: -20px;
			.el-checkbox__label{
				color:rgb(121, 121, 121)
			}
		}
		.reinstall-tip {
			width:100%;
			font-size:15px;
			color:#797979;
			word-break: break-word;
			padding-bottom: 5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/DeleteMirror.vue